import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@/model/consts/queryKeys";

import { setLocalStorage } from "@/shared/lib/local-storage";
import { LOCAL_STORAGE_VARIABLES } from "@/shared/lib/local-storage/constants/local-storage";
import { showErrorForDevelop } from "@/shared/lib/show-error-for-develop";

import { USER_API } from "../endpoints";

export const useLoginByInitData = (
  initDataString?: string,
  refCode?: string,
) => {
  const query = useQuery({
    queryKey: [QUERY_KEYS.USERS.LOGIN],
    queryFn: async () => {
      if (initDataString) {
        try {
          const result = await USER_API.loginByInitData({
            params: {
              initData: { initData: initDataString, refCode },
            },
          });

          const newToken = result.data.token;
          setLocalStorage(LOCAL_STORAGE_VARIABLES.TOKEN, newToken);
          return result;
        } catch (error) {
          showErrorForDevelop("error-useLoginByInitData", error);
        }
      }
      return Promise.reject("Invalid init data");
    },
    staleTime: 60 * 60 * 1000,
    select: (data) => data,
  });

  return { ...query };
};
